/* EditSocialLinks.js */

import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
// import AppBar1 from '../../components/commom/AppBar1';
import Footer1 from '../../components/commom/Footer1';
import SocialLinksForm from '../../components/remix/SocialLinksForm';
import { useAuth } from '../../context/auth/AuthContext';
import PSO from '../../services/PSO';
import Strings from '../../translations/Translations';
import AppBar2 from '../../components/commom/AppBar2/AppBar2';

export default function EditSocialLinks() {
  const history = useHistory();
  const { rid } = useParams();
  const { authenticated } = useAuth();

  const [remixPars, setRemixPars] = useState();

  const callBackAfterCreation = () =>  history.push('/dashboard');

  const getRemixPars = useCallback(async () => {
    if (rid) {
      try {
        const response = await PSO.getRemixPars({ un: authenticated.un, al: authenticated.al, rid});
        if (response.result === 'success' && response.its && response.its.length > 0) {
          setRemixPars(response.its[0]);
        }
      } catch (err) {
        toast.error(Strings('error_on_getting_parameters'));
        console.error(Strings('error_on_getting_parameters'));
      }
    }
  }, [rid, authenticated, setRemixPars]);
  useEffect(() => { getRemixPars(); }, [getRemixPars]);
  
  return (
    <>

      <AppBar2 />

      <SocialLinksForm
        openTinyPageAfterCreation={true}
        callBackAfterCreation={callBackAfterCreation}
        editMode
        remixPars={remixPars}
      />

      <Footer1 />

    </>
  );
}
